export default __webpack_public_path__ + "static/media/2dView.3ea40e74.png";